import React, {Component} from "react";
import {
    Button,
    Form,
} from "semantic-ui-react";



export default class CreateNotesForm extends Component {
    state = { description: ''}
    render() {
        const { submitForm, item} = this.props;
        const { description } = this.state
        console.log('item', item)
        return (
            <Form className={'widthFluid'}>
                <Form.Group widths='equal'>
                    <Form.Field>
                        <Form.TextArea
                            fluid={true}
                            label='Notes'
                            placeholder='notes'
                            value={description}
                            onChange={(event) => this.setState({description: event.target.value})}
                        />
                    </Form.Field>
                </Form.Group>
                <Form.Group widths='equal' className="float-right">
                    <Form.Field>
                        <Button secondary={true} onClick=''>
                            Cancel
                        </Button>
                        <Button
                            className='ui primary button'
                            onClick={(event) => {
                                    event.preventDefault()
                                    submitForm.submitForm({description, downTimeIssueId: item.id})
                                }
                            }
                        >
                            Save
                        </Button>
                    </Form.Field>
                </Form.Group>
            </Form>
        );
    }
}
